module.exports = __webpack_public_path__ + "img/framenew_box11.8ae62631.jpg";